import { Container, Typography, Box, Link } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import SubmitButton from "../components/common/SubmitButton";
import KycAnimation from "../components/Lottie/KycAnimation";
import configData from "../Config";
import PendingMessage from "../components/common/PendingMessage";
import PopUp from "../components/common/PopUp";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingDots from "../components/Lottie/LoadingDots";
import Backdrop from "../components/common/Backdrop";
import { apis } from "../services/apiService";
import { CONSTANTS } from "../utils/constant";
import { convertSEcToMin } from "../utils/utils";
import styles from "../Style/Modules/pendingKyc.module.css";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function PendingKYC() {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  let location = useLocation();
  const [videoKYCStatus, setVideoKYCStatus] = useState("");
  const [resultData, setResultData] = useState("");
  const [kycStatus, setKYCStatus] = useState(false);
  const [apiCountTimer, setAPICountTimer] = useState(
    CONSTANTS.VKYCStatusapitimeOut
  );
  const [finalErr, setFinalErr] = useState("");
  const timerRef = useRef(null);

  let checkVKYCapistatus = async () => {
    setKYCStatus(true);
    timerRef.current = setInterval(() => {
      setAPICountTimer((counter) => counter - 1);
    }, CONSTANTS.pendingKYCInterval.INTERVALTIMER_0);
    let timer = 0;
    const apiCheck = setInterval(async () => {
      if (timer < CONSTANTS.pendingKYCInterval.MAXTIMER_1) {
        try {
          timer += CONSTANTS.pendingKYCInterval.INTERVALTIMER_1;
          const reqData = {
            // aid: resultData.AppId,
            aid: location.state.AppId,
          };
          let resp = await apis.postApi(
            configData.API_URL + "Vkyc/VKYCStatus",
            reqData
          );
          let result = await resp.json();
          if (resp?.status === 200) {
            if (result?.data.data[0].vcipidstatus === "4") {
              let data = {
                AppId: location.state.AppId,
              };
              clearApiCheck();
              clearInterval(timerRef.current);
              navigate("/new-approved-limit", { state: data });
            } else if (result?.data.data[0].vcipidstatus === "3") {
              setVideoKYCStatus(
                "your video KYC is rejected by agent, kindly connect with administration."
              );
              clearApiCheck();
              clearInterval(timerRef.current);
              setKYCStatus(false);
            } else if (result?.data.data[0].vcipidstatus === "5") {
              setVideoKYCStatus(
                "your video KYC is rejected by auditor, kindly connect with administration."
              );
              clearApiCheck();
              clearInterval(timerRef.current);
              setKYCStatus(false);
            } else {
              setVideoKYCStatus("your video KYC is in progress");
            }
          }
        } catch (error) {
          const errorResult = JSON.parse(error?.message);
          clearApiCheck();
          setKYCStatus(false);
          // clearInterval(apiCheck);
          clearInterval(timerRef.current);
          setVideoKYCStatus("Video KYC failed please relogin and try again");
        }
      } else if (timer >= CONSTANTS.pendingKYCInterval.MAXTIMER_1) {
        clearApiCheck();
        setVideoKYCStatus("Due to timeout please refresh the page for proceed");
        clearInterval(timerRef.current);
        setKYCStatus(false);
      }
    }, CONSTANTS.pendingKYCInterval.INTERVALTIMER_1);

    function clearApiCheck() {
      console.log("clear API function call");
      timer = 0;
      setAPICountTimer(CONSTANTS.VKYCStatusapitimeOut);
      clearInterval(apiCheck);
      clearInterval(timerRef.current);
      setKYCStatus(false);
    }
  };

  useEffect(() => {
    let createLinkAPICcall = async () => {
      try {
        setLoading(true);
        const reqData = {
          aid: location.state.AppId,
        };
        let resp = await apis.postApi(
          configData.API_URL + "Vkyc/VKYCCreateLink",
          reqData
        );
        let result = await resp.json();
        if (resp?.status === 200) {
          setResultData(result.data);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        const errorResult = JSON.parse(error?.message);
        setVideoKYCStatus(errorResult?.statusMessage);
      }
    };
    // createLinkAPICcall();
    const VKYCAPIcheck = async () => {
      try {
        setLoading(true);
        const reqData = {
          // aid: resultData.AppId,
          aid: location.state.AppId,
        };
        let resp = await apis.postApi(
          configData.API_URL + "Vkyc/VKYCStatus",
          reqData
        );
        let result = await resp.json();
        if (resp?.status === 200) {
          if (result?.data.data[0].vcipidstatus === "4") {
            setLoading(false);
            let data = {
              AppId: location.state.AppId,
            };
            navigate("/new-approved-limit", { state: data });
          } else if (result?.data.data[0].vcipidstatus === "3") {
            setVideoKYCStatus(
              "your video KYC is rejected by agent, kindly connect with administration."
            );
            setLoading(false);
            createLinkAPICcall();
          } else if (result?.data.data[0].vcipidstatus === "5") {
            setVideoKYCStatus(
              "your video KYC is rejected by auditor, kindly connect with administration."
            );
            setLoading(false);
            createLinkAPICcall();
          } else {
            setVideoKYCStatus("your video KYC is in progress");
            // setKYCPreStatus(true);
            setLoading(false);
            createLinkAPICcall();
          }
        }
      } catch (error) {
        const errorResult = JSON.parse(error?.message);
        setLoading(false);
        createLinkAPICcall();
      }
    };
    VKYCAPIcheck();
    if (apiCountTimer === 0) {
      clearInterval(timerRef.current);
    }
  }, []);

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={13} />
        <Box py={5} className={styles.pendingKycBox}>
          <KycAnimation />
          <Box className={styles.pendingKycBox1}>
            <Typography
              variant="h2"
              sx={{ mt: 1, mb: 2, fontWeight: "bold", color: "#0D1C6E" }}
            >
              {t("Video Kyc Pending")}
            </Typography>
            <Typography variant="p" color="info" sx={{ textAlign: "center" }}>
              {t("Your video KYC is pending please complete it.")}
            </Typography>
            <Typography
              variant="p"
              color="info"
              sx={{ textAlign: "center", mt: "10px" }}
            >
              {t("Please click on below link to complete your video KYC.")}
            </Typography>
            {/* {resultData && (
              <img
                style={{
                  width: "40%",
                  height: "40%",
                  position: "relative",
                  // left: "67%",
                  // bottom: "27.5%",
                }}
                src={`data:image/png;base64,${resultData.qrimage}`}
                alt="QR Image"
              />
            )} */}
            {resultData.vciplink && (
              <Link
                sx={{
                  mt: "10px",
                  mb: "10px",
                  cursor: "pointer",
                  color: "blue",
                }}
                onClick={() => {
                  convertSEcToMin(apiCountTimer);
                  checkVKYCapistatus();
                  window.open(resultData.vciplink, "_blank");
                }}
              >
                {resultData.vciplink}
              </Link>
            )}
            {videoKYCStatus && (
              <Typography
                variant="h6"
                color="red"
                sx={{ textAlign: "center", mt: "10px" }}
              >
                {videoKYCStatus}
              </Typography>
            )}
            {/* {kycPreStatus && (
              <Typography
                variant="h6"
                color="blue"
                sx={{ textAlign: "center", mt: "10px" }}
              >
                your video KYC is in progress
              </Typography>
            )} */}
            {/* {kycReject && (
              <Typography
                variant="h6"
                color="red"
                sx={{ textAlign: "center", mt: "10px" }}
              >
                your video KVC is rejected by auditor
              </Typography>
            )} */}
            {/* {kycPreReject && (
              <Typography
                variant="h6"
                color="info"
                sx={{ textAlign: "center", mt: "10px" }}
              >
                your video KVC is rejected by auditor
              </Typography>
            )} */}
            {/* {timeOutStatus && (
              <Typography
                variant="h6"
                color="red"
                sx={{ textAlign: "center", mt: "10px" }}
              >
                Due to timeout please refresh the page for proceed
              </Typography>
            )} */}
            {/* {showPopUp && (
              <PopUp>
                <PendingMessage
                  msg="Video KYC still pending."
                  onCancel={handleCancel}
                />
              </PopUp>
            )} */}
          </Box>
        </Box>
        {kycStatus && (
          <Backdrop ax="center">
            <LoadingDots
              displayText={
                // kycStatus &&
                `page will refresh shortly after ${convertSEcToMin(
                  apiCountTimer
                )} minute`
              }
            />
          </Backdrop>
        )}
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
        {finalErr && (
          <Backdrop ax="center">
            <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
          </Backdrop>
        )}
      </Container>
    </>
  );
}
